import { put, call } from 'redux-saga/effects';
import MulesoftDataService from './../../services/mulesoftData.services';
import { constants } from './../../constants';

import { 
  updatereviewDetailsFlag,
  toggleAlertShowStatus,
  setRequestId,
  setShowLoaderStatus
  } from './../actions';


export default function * submitInfo (args) {
  try {
    const res = yield call([MulesoftDataService, 'submitInfo'], args.payload);
    yield put(setRequestId(res.data));
    yield put(updatereviewDetailsFlag());
    yield put(setShowLoaderStatus(false));
    args.payload.callback();
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_SAVE_ERROR
    }));
    yield put(setShowLoaderStatus(false));
  }

}